import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=7a4b7c36&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=7a4b7c36&prod&scoped=true&lang=css"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=7a4b7c36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b7c36",
  null
  
)

export default component.exports